<template>
    <div class="main">
        <c-panel title="CARTEIRINHAS ESCOLARES" titleIcon="fas fa-id-card">

            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Tipo de carteirinha">
                            <el-select v-model="aba" placeholder="Selecione o tipo" style="width:100%;">
                                <el-option label="Aluno individual" value="alunoIndividual"></el-option>
                                <el-option label="Aluno por turma" value="alunoTurma"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <el-form label-position="top" v-if="aba === 'alunoTurma' && mostraInstituicao">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Instituição">
                            <el-select v-model="instituicaoSel" filterable clearable placeholder="Selecione a instituição" style="width:100%;">
                                <el-option v-for="i in listaInstituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div v-if="aba === 'alunoIndividual'" class="u-mt-15">
                <el-form label-position="top">
                    <el-row :gutter="10">
                        <el-col :sm="24">
                            <el-form-item label="Aluno">
                                <el-select v-model="alunoId" filterable remote :remote-method="buscarAluno" :loading="loadAluno"
                                    placeholder="Digite o nome..." style="width:100%;">
                                    <el-option v-for="a in alunos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="24" style="padding-top:24px; text-align: right;">
                            <el-button type="primary" icon="el-icon-printer" :disabled="!alunoId" @click="imprimirAluno">GERAR CARTEIRINHA</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div v-if="aba === 'alunoTurma'" class="u-mt-15">
                <el-form label-position="top">
                    <el-row :gutter="10">
                        <el-col :sm="24">
                            <el-form-item label="Turma">
                                <el-select v-model="turmaId" filterable placeholder="Selecione" style="width:100%;">
                                    <el-option v-for="t in turmas" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="24" style="padding-top:24px; text-align: right;">
                            <el-button type="primary" icon="el-icon-printer" :disabled="!turmaId" @click="imprimirTurma">GERAR LOTE</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

        </c-panel>
    </div>
</template>

<script>
export default {
    data () {
        return {
            aba: 'alunoIndividual',
            alunoId: null, alunos: [], loadAluno: false,
            turmaId: null, turmas: [],
            instituicaoSel: null
        }
    },
    computed: {
        // Perfis de rede escolhem a instituição aqui; os demais usam a do cabeçalho. Sem escola no cabeçalho, qualquer um escolhe.
        ehRede () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        mostraInstituicao () { return this.ehRede || !this.instHeader() },
        listaInstituicoes () {
            const v = this.$store.state.instituicoes
            return Array.isArray(v) ? v : Object.values(v || {})
        }
    },
    mounted () { this.carregarTurmas() },
    watch: {
        '$store.state.config.instituicao.id' () { this.carregarTurmas() },
        instituicaoSel () { this.turmaId = null; this.carregarTurmas() }
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        instHeader () { const i = this.$store.state.config.instituicao; return i && i.id ? i.id : null },
        /** Instituição em uso: a escolhida na tela (rede) ou, na falta dela, a do cabeçalho. */
        instId () { return this.instituicaoSel || this.instHeader() },

        buscarAluno (q) {
            if (!q || q.length < 2) { this.alunos = []; return }
            this.loadAluno = true
            this.$axios.post(`${this.baseUrl()}/api/aluno/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(r => { this.alunos = r.data || []; this.loadAluno = false })
                .catch(() => { this.loadAluno = false })
        },
        carregarTurmas () {
            this.turmas = []

            const i = this.instId()
            const p = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null
            if (!i || !p) return

            // Devolve as turmas agrupadas por curso; a lista da tela é plana, ordenada pelo nome.
            this.$axios.get(`${this.baseUrl()}/api/turma/getAllTurmas/${i}/${p}`, this.$store.getters.getHeaderAuth)
                .then(r => {
                    this.turmas = Object.values(r.data || {}).reduce((todas, grupo) => todas.concat(grupo), [])
                        .sort((a, b) => a.nome.localeCompare(b.nome))
                })
                .catch(() => { this.turmas = [] })
        },

        abrirPdf (url) {
            this.$axios.get(url, { ...this.$store.getters.getHeaderAuth, responseType: 'blob' })
                .then(r => {
                    // Quando o backend retorna {erro:'...'} em 200 OK, o body chega como blob
                    // application/json — não tentar abrir como PDF. Lê texto e exibe alert.
                    const tipo = (r.headers && (r.headers['content-type'] || r.headers['Content-Type'])) || ''
                    if (tipo.indexOf('application/json') !== -1) {
                        const reader = new FileReader()
                        reader.onload = () => {
                            try {
                                const obj = JSON.parse(reader.result)
                                const msg = (obj && obj.erro)
                                    ? (typeof obj.erro === 'string' ? obj.erro : obj.erro.text || JSON.stringify(obj.erro))
                                    : 'Falha ao gerar PDF.'
                                window.eventBus.$emit('alert', { msg, type: 'warning' })
                            } catch (e) {
                                window.eventBus.$emit('alert', { msg: 'Falha ao gerar PDF.', type: 'warning' })
                            }
                        }
                        reader.readAsText(r.data)
                        return
                    }
                    const blob = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }))
                    window.open(blob, '_blank')
                })
                .catch(e => this.$store.commit('throwException', e))
        },
        imprimirAluno ()   { this.abrirPdf(`${this.baseUrl()}/api/carteirinha/aluno/${this.alunoId}`) },
        imprimirTurma ()   { this.abrirPdf(`${this.baseUrl()}/api/carteirinha/loteTurma/${this.turmaId}`) }
    }
}
</script>
